import { useCallback, useState } from 'react';

/**
 * Enables reCAPTCHA only after the form passes built-in constraint validation (required, email, etc.).
 */
export function useRecaptchaGate(formRef, captchaRef, setCaptchaToken) {
  const [recaptchaAllowed, setRecaptchaAllowed] = useState(false);

  const syncRecaptchaGate = useCallback(() => {
    const form = formRef.current;
    const valid = Boolean(form?.checkValidity());
    if (!valid) {
      setCaptchaToken('');
      captchaRef.current?.reset?.();
    }
    setRecaptchaAllowed(valid);
  }, [formRef, captchaRef, setCaptchaToken]);

  return [recaptchaAllowed, syncRecaptchaGate];
}
